// Share-link pages carry their secret in the URL fragment, so it must never reach Datadog.
const SHARED_PAGE_PATH_PREFIX = '/shared/';

/**
 * Pure: whether `pathname` is a share-link page. Session replay is not recorded there (the
 * viewer is outside the org, and the page carries a secret), and its auth failures render on
 * the page instead of redirecting to the staff login. Imports nothing, so the axios setup can
 * use it.
 */
export const isSharedPagePath = (pathname: string): boolean =>
  pathname.startsWith(SHARED_PAGE_PATH_PREFIX);
